/**
 * The name of the service worker file in `build` directory.
 * It's used by `vite.config.ts` and `ServiceWorkerLoader` to register the service worker.
 */
export const SERVICE_WORKER_NAME = 'service-worker.js';
